import React, { useContext, useEffect } from 'react';

import RouterProvider from './Routes';
import NavBar from './components/Navigation/NavBar';
import AlertDisplay from './components/AlertDisplay';

import InactivityTimeout from './components/InactivityTimeout';

import { AuthContext } from './contexts';

import useLogRocket from './hooks/useLogRocket';

import './App.scss';

import { getTenantFromUrl, getThemeConfig } from './utils/tenant';

export default function App() {
  const isAuthenticated = useContext(AuthContext);

  useEffect(() => {
    const tenant = getTenantFromUrl();
    const theme = getThemeConfig(tenant);
    document.title = theme.title || 'Valuation Software';
    if (theme.favicon) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = `${process.env.PUBLIC_URL}/${theme.favicon}`;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }, []);

  useLogRocket();

  if (isAuthenticated) {
    return (
      <main className="App">
        <AlertDisplay />
        <InactivityTimeout />
        <NavBar />
        <RouterProvider />
      </main>
    );
  }
}
